<script setup lang="ts">
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import { useI18n } from "vue-i18n";
import { defineEmits } from "vue";
import { useUserStore } from "@/stores/userStore";

const { t } = useI18n();
const userStore = useUserStore();

const emits = defineEmits(["click"]);
</script>

<template>
  <button
    class="bg-white h-[56px] relative flex items-center justify-between px-1 md:px-2 rounded-full"
    :class="userStore.user !== null ? 'aspect-square' : 'w-[147px]'"
    @click="emits('click')"
  >
    <img
      v-if="userStore.user !== null"
      src="@/assets/icons/user.svg"
      class="size-7 mx-auto"
      alt="user icon"
    />
    <template v-else>
      <span class="text-active mx-auto text-base leading-[20px]">
        {{ t("buttons.auth.login") }}
      </span>
      <span
        class="min-h-[38px] min-w-[38px] md:min-h-[46px] md:min-w-[46px] flex items-center justify-center rounded-full bg-orange-gradient text-white transition-transform z-10 ml-auto"
      >
        <ArrowIcon class="rotate-45" />
      </span>
    </template>
  </button>
</template>
